module.exports = __webpack_public_path__ + "src/images/products/active/22_Drop Shoulder Hoodie- Sandstone.png";